"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ShopLanguages;
(function (ShopLanguages) {
    ShopLanguages["DE"] = "de-DE";
    ShopLanguages["FR"] = "fr-FR";
})(ShopLanguages || (ShopLanguages = {}));
exports.default = ShopLanguages;
